import { RequestClientInterfaceService } from './request-client.interface.service';
import { AxiosResponse, ResponseType } from 'axios';
import {
    COGNITO_TOKEN_NAME,
    DEALER_PORTAL_URL,
    PERMISSIONS_TOKEN_NAME,
} from '../config';
import { HttpMethod, HttpStatusCode } from '../utils/enums/http-method.enum';

/**
 * Class responsible for manage the API calls and data request of the App
 */
export class FinancingService {
    private readonly dealerPortalUrlStructure = `${DEALER_PORTAL_URL}`;
    private client: RequestClientInterfaceService;
    private headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: '',
    };
    /**
     * Instantiates a new ClientService
     */
    constructor() {
        this.client = new RequestClientInterfaceService();
    }

    /**
     * Retrieves the dealer data
     * @param brand brand for handbook document
     * @param country country for handbook document
     * @param language language for handbook document
     * @param type type for handbook document
     */
    public async getDocumentByType(
        brand: string,
        country: string,
        language: string,
        type: string,
    ): Promise<AxiosResponse> {
        const url = `${this.dealerPortalUrlStructure}/getDocumentByType`;
        const cognitoToken = window.sessionStorage.getItem(COGNITO_TOKEN_NAME);
        const permissionsToken = window.sessionStorage.getItem(
            PERMISSIONS_TOKEN_NAME,
        );

        const request = {
            method: HttpMethod.post,
            url,
            headers: {
                ...this.headers,
                Authorization: `Bearer ${cognitoToken}`,
            },
            data: {
                brand,
                country,
                language,
                type,
                jwtToken: permissionsToken,
            },
            responseType: 'blob' as ResponseType,
        };
        return this.client.sendRequest(request);
    }

    validateNotFound(status: number) {
        return (
            status == HttpStatusCode.NOT_FOUND ||
            status == HttpStatusCode.SUCCESS
        );
    }

    public abort() {
        this.client.controller.abort();
    }
}
